export default "__VITE_ASSET__x$wWPd2j__"